import { render, staticRenderFns } from "./ProfileOptions.vue?vue&type=template&id=87eb5a08&"
import script from "./ProfileOptions.vue?vue&type=script&lang=js&"
export * from "./ProfileOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOptions.vue?vue&type=style&index=0&id=87eb5a08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports